export default __webpack_public_path__ + "3f505325725ab5267e6ac335429bfbd2.png";